import React, { useState, useEffect } from 'react';
import faceImage from '@/assets/kevin_3.jpg';

import { useLanguage } from '@/context/LanguageContext';

const StatusHeader = () => {
    const { t } = useLanguage();
    const [isOnline, setIsOnline] = useState(false);

    useEffect(() => {
        const checkOnlineStatus = () => {
            // Skip check during pre-rendering to avoid hydration mismatch
            if (window.__PRERENDER__ || navigator.userAgent.includes("AgileCoachPrerender")) return;

            // Get current time in Berlin
            const now = new Date();
            const berlinTime = new Date(now.toLocaleString("en-US", { timeZone: "Europe/Berlin" }));

            const day = berlinTime.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
            const hour = berlinTime.getHours();
            const minute = berlinTime.getMinutes();
            const currentTime = hour * 60 + minute;

            // Helper to convert "HH:MM" to minutes
            const toMins = (h: number, m: number) => h * 60 + m;

            let online = false;

            // Time ranges
            // Mon: 08:03 - 15:34
            // Tue: 08:06 - 15:22, 20:20 - 22:31
            // Wed: 08:55 - 15:40, 20:20 - 22:31
            // Thu: 07:51 - 17:03, 20:20 - 22:31
            // Fri: 07:57 - 16:52
            // Sat: 08:08 - 09:00, 20:20 - 22:31
            // Sun: 07:59 - 08:52, 20:20 - 22:31

            const checkRange = (startH: number, startM: number, endH: number, endM: number) => {
                const start = toMins(startH, startM);
                const end = toMins(endH, endM);
                return currentTime >= start && currentTime <= end;
            };

            switch (day) {
                case 1: // Monday
                    if (checkRange(8, 3, 15, 34)) online = true;
                    break;
                case 2: // Tuesday
                    if (checkRange(8, 6, 15, 22) || checkRange(20, 20, 22, 31)) online = true;
                    break;
                case 3: // Wednesday
                    if (checkRange(8, 55, 15, 40) || checkRange(20, 20, 22, 31)) online = true;
                    break;
                case 4: // Thursday
                    if (checkRange(7, 51, 17, 3) || checkRange(20, 20, 22, 31)) online = true;
                    break;
                case 5: // Friday
                    if (checkRange(7, 57, 16, 52)) online = true;
                    break;
                case 6: // Saturday
                    if (checkRange(8, 8, 9, 0) || checkRange(20, 20, 22, 31)) online = true;
                    break;
                case 0: // Sunday
                    if (checkRange(7, 59, 8, 52) || checkRange(20, 20, 22, 31)) online = true;
                    break;
            }

            setIsOnline(online);
        };

        checkOnlineStatus();
        const interval = setInterval(checkOnlineStatus, 60000); // Check every minute
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="absolute top-6 left-4 md:left-8 z-30 flex items-center gap-3 pointer-events-none" role="status" aria-live="polite">
            <div className="relative pointer-events-auto">
                <div className="relative w-10 h-10 md:w-12 md:h-12 rounded-full border-2 border-background shadow-lg overflow-hidden">
                    <img
                        src={faceImage}
                        alt="Kevin Rassner - Profile Photo"
                        title="Kevin Rassner - Profile Photo"
                        className="w-full h-full object-cover"
                    />
                </div>
                <div
                    suppressHydrationWarning
                    className={`absolute bottom-0 right-0 w-3 h-3 md:w-3.5 md:h-3.5 rounded-full border-2 border-background ${isOnline ? 'bg-green-500 animate-pulse' : 'bg-gray-400'
                        }`}
                />
            </div>
            <span suppressHydrationWarning className="text-xs md:text-sm font-medium text-muted-foreground pointer-events-auto">
                {isOnline ? t('status.online') : t('status.offline')}
            </span>
        </div>
    );
};

export default StatusHeader;
